import { isQA } from '../constants/apiEnvironments';
const KNOWN_DOMAINS_REGEXES = [/^www\.inbound\.com$/, /^([a-z0-9-]+\.)?hubspot?\.([a-z]{2,3})$/, /^([a-z0-9-]+\.)?wthubspot?\.([a-z]{2,3})$/, /^website\.grader\.com$/];
if (isQA) {
  KNOWN_DOMAINS_REGEXES.push(/^local\.hsappstatic\.net$/, /^([a-z0-9-]+\.)?hubspotqa?\.([a-z]{2,3})$/, /^([a-z0-9-]+\.)?wthubspotqa?\.([a-z]{2,3})$/, /^private.hubteamqa.com$/);
}
export const isKnownDomainEmbeddingSignup = domain => {
  return KNOWN_DOMAINS_REGEXES.some(regex => domain && domain.match(regex));
};